import {useEffect, useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {
	selectPrevMode,
	selectContacts,
	createChatRoom,
	setMode
} from '../messageCenterSlice'
import Select from "react-select"
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import CenteredLoader from '../../CenteredLoader/CenteredLoader'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {capitalize} from '../../../util/util'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import styles from './RoomCreator.module.css'

const accountTypeValueColor = type =>({
	trainer:'rgba(240, 115, 144,0.2)',
	gym:'rgba(142, 89, 240,0.2)',
	client:'rgba(99, 191, 98,0.2)'
}[type])

const RoomCreator = ()=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const {status:contactsStatus,byType:contactsByType} = useSelector(selectContacts)
	const [createStatus,setCreateStatus] = useState('idle')
	const [contactMap, setContactMap] =useState([{ // updates selected contacts map
		data: []
	}])
	const [openSelections, setOpenSelections] = useState(false)
	const groupTypes = Object.keys(contactsByType)
	const groupedSelectOptions = Object.entries(contactsByType).map(([contactType,contacts])=>(
		{
			label:`${contactType}${contacts.length>1?'s':''}`,
			options:contacts.map(contact=>({
				label:contact.user_name,
				value:contact.user_id_number,
				type:contactType
			}))
		}
	))
	const [selectedContacts,setSelectedContacts] = useState([])
	const [roomName,setRoomName] = useState('')
	const prevMode = useSelector(selectPrevMode)
	const handleCancel = () => { dispatch(setMode(prevMode)) }
	const handleCreate = () => {
		const group_ids = selectedContacts.map(contact=>contact.value)
		setCreateStatus('pending')
		statusDispatch(createChatRoom({group_ids,name:roomName}),'chat room','create').then(()=>{
			setSelectedContacts([])
			setCreateStatus('idle')
		})
	}

	const getSelectionOptionsLength = () => {
		let count = 0
		groupedSelectOptions.forEach(groupOptions => {
			count += groupOptions.options.length
		})
		return count
	}

	const handleSelectOption = (option) => {
		let newContactList = selectedContacts
		newContactList.push(option)
		setSelectedContacts(newContactList)
		setContactMap([{ //although contactMap is unused, putting this here updates the map on line ~114 
			data: [newContactList]
		}])
	}

	const filterOptions = (options) => {
		let newOptions = options
		selectedContacts.forEach((contact) => {
			newOptions = (newOptions.filter((option)=> option.label !== contact.label))
		})
		return newOptions
	}

	const handleRemoveContact = (option, e) => {
		e.stopPropagation()
		let newContactList = selectedContacts
		newContactList = newContactList.filter((contactOption) => contactOption.label !== option.label)
		setSelectedContacts(newContactList)
	}

	const handleClearSelections = () => {
		setSelectedContacts([])
	}

	const handleAddAll = (type) => {
		let newContactList = selectedContacts
		newContactList = newContactList.filter((contactOption) => contactOption.label !== type)
		groupedSelectOptions.forEach((groupOption) => {
			if(groupOption.label === type){
				groupOption.options.forEach((option)=> {
					newContactList.push(option)
				})
			}
		})
		setSelectedContacts(newContactList)
	}

	if(contactsStatus === 'pending') return <CenteredLoader/>
	return (
		<div style={{flex:'1 1 auto',overflow:'hidden'}} className="p-5 d-flex justify-content-center" id={styles.roomContainer}>
			<div style={{width:'800px',maxWidth:'100%'}}>
				<div>Select members for this new group:</div>
				<div className="d-flex align-items-center">
					{groupTypes.map(t=>(
						<div className="d-flex align-items-center mr-3">
							<span style={{
								backgroundColor:accountTypeValueColor(t),
								border:'1px solid #ccc',
								display:'inline-block',
								borderRadius:'100%',
								marginRight:'4px',
								width:'16px',
								height:'16px'
							}}/>
							{capitalize(t)}
						</div>
					))}
				</div>

				{/* CUSTOM MULTI SELECT */}
				{/* so users can make selections without the dropdown closing  */}
				<div  style={{width:'100%'}} tabIndex="0" onBlur={() => setOpenSelections(false)}>
					<div className={styles.valueContainerContainer} onClick={() => setOpenSelections(!openSelections)}>
						<div className={styles.valueContainer} key={selectedContacts}>
							{selectedContacts.length === 0 &&
							<div className={styles.placeHolder}>Select...</div>
							}
							{selectedContacts.map((option)=>{
								return(
									<div className={styles.valueBox} style={{backgroundColor:accountTypeValueColor(option.type)}}>
										<p className={styles.valueBoxText} style={{marginBottom:'0'}}> {option.label}</p>
										<p className={styles.valueBoxClose} onClick={(e) => handleRemoveContact(option,e)}>
											<i class="fa fa-times" style={{color: 'hsl(0, 0%, 70%)'}}></i>
										</p>
									</div>
								)
							})}
						</div>
						<div className={styles.IndicatorsContainer} >
							{selectedContacts.length > 0 &&
								<div className={styles.indicatorContainer} onClick={handleClearSelections}><i class="fa fa-times"></i></div>
							}
							{selectedContacts.length !== getSelectionOptionsLength() && 
								<>
									<span className={styles.indicatorSeparator}></span>
									<div className={styles.indicatorContainer} onClick={() => setOpenSelections(!openSelections)}><i class="fa fa-chevron-down"></i></div>
								</>
							}

							</div>
					</div>
					{openSelections && selectedContacts.length !== getSelectionOptionsLength() ? 		
						<div className={styles.menu}>
							<div className={styles.MenuList}>
								{groupedSelectOptions.map((groupOption) => {
									return (
										<>
											{filterOptions(groupOption.options).length > 0 &&
												<div className={styles.group}>
													{capitalize(groupOption.label)}
													{groupOption.label !== 'gym' && 
														<OverlayTrigger 
															delay={{ show: 150}}
															overlay={
																<Tooltip>Click to add all {groupOption.label}</Tooltip>
															}
														>
														<i class="fa fa-plus-circle" style={{marginLeft:'10px', color:'#28a745'}} onClick={() => handleAddAll(groupOption.label)}></i>
														</OverlayTrigger>
													}
		
												</div>									
											}
											{filterOptions(groupOption.options).map((option) => {
												return(
													<div className={styles.option} onClick={() => handleSelectOption(option)}>
														<p >{option.label}</p>
													</div>
												)
											})} 
										</>
									)
								})}
							</div>
						</div>
						:
						null
					}
					<div className="mt-2">
						<label>Room Name</label>
						<Form.Control 
							onChange={e=>{
								setRoomName(e.target.value)
							}}
							placeHolder="room name (optional)" 
							value={roomName}
							size="sm"
						/>
					</div>
				</div>
				<div className="text-right mt-2">
					<Button 
						disabled={createStatus==='pending'}
						variant="danger" 
						onClick={handleCancel} 
						size="sm"
					>
						Cancel
					</Button>
					<Button 
						disabled={createStatus==='pending'}
						onClick={handleCreate} 
						variant="success"
						className="ml-2" 
						size="sm"
					>
						{
							createStatus === 'pending' ? 
							<Spinner animation="border" size="sm"/>:
							"Create Chat Room"
						}
					</Button>
				</div>
			</div>
		</div>
	)
}

export default RoomCreator